const LIVE_PAGE_SCROLL_ROOT_SELECTOR = '.fabric-editor-popup-scroll-parent';
const MAIN_CONTENT_ID = 'AkMainContent';

export type FindRenderedSmartLinkElementOptions = {
	root: ParentNode;
	url: string;
};

export type FindRenderedSmartLinkElementResult =
	| { status: 'found'; element: HTMLElement }
	| { status: 'not_found' };

export const getSmartLinkContentRoot = (isLivePage: boolean): ParentNode | undefined => {
	const currentDocument = typeof document === 'undefined' ? undefined : document;
	if (!currentDocument) {
		return undefined;
	}

	if (isLivePage) {
		return currentDocument.querySelector(LIVE_PAGE_SCROLL_ROOT_SELECTOR) ?? undefined;
	}

	return currentDocument.getElementById(MAIN_CONTENT_ID) ?? currentDocument;
};

export const findRenderedSmartLinkElement = ({
	root,
	url,
}: FindRenderedSmartLinkElementOptions): FindRenderedSmartLinkElementResult => {
	const element = Array.from(root.querySelectorAll<HTMLAnchorElement>('a[href]')).find(
		(anchor) => anchor.getAttribute('href') === url,
	);

	return element ? { status: 'found', element } : { status: 'not_found' };
};
